import { Avatar } from '@mui/material'

export const ProjectAvatar = ({
  name,
  size,
  imageSrc,
}: {
  name: string
  size: number
  imageSrc?: string | null
}) => {
  if (!imageSrc) {
    return (
      <Avatar
        sx={{
          bgcolor: 'primary.main',
          opacity: 0.8,
          width: size,
          height: size,
          fontSize: '14px',
          border: '1px solid white',
        }}
      >
        {name.charAt(0)}
      </Avatar>
    )
  }

  return (
    <Avatar
      src={imageSrc}
      sx={{ width: size, height: size, border: '1px solid white' }}
    />
  )
}
